import { Component, computed, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { BulkEditAction } from '../../services/events.service';

@Component({
  selector: 'app-edit-bulk-confirm',
  templateUrl: './edit-bulk-confirm.component.html',
  imports: [BoDialogComponent, ButtonComponent],
})
export class EditBulkConfirmComponent {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);

  readonly action = input.required<BulkEditAction>();
  readonly count = input.required<number>();

  protected readonly actionVerb = computed(() => this.action());

  protected readonly actionLabel = computed(
    () =>
      ({
        enable: 'Enable all',
        disable: 'Disable all',
        delete: 'Delete all',
      })[this.action()]
  );

  public onConfirm() {
    this.dialogRef.close('success');
  }

  public onDismiss = () => {
    this.dialogRef.close('cancel');
  };
}
